import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=1e736a32&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=ts"
export * from "./SingleOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e736a32",
  null
  
)

export default component.exports